export default function formatDate(dateString) {
  try {
    const options = { year: 'numeric', month: 'short', day: 'numeric' } as any;
    const date = new Date(dateString);
    return new Intl.DateTimeFormat('en-US', options).format(date);
  } catch (error) {
    return '';
  }
}
